<template>
  <g>
    <Seat v-for="seat, seatID in model.row.seats" :model="{id: seatID, seat: seat}" :row="model"/>
  </g>
</template>

<script>
export default {
  props: ['model', 'disabled'],
  name: 'Row',
}
</script>



// WEBPACK FOOTER //
// src/components/Theatre/Row.vue